var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}},[_c('path',{attrs:{"d":"m2 9.884 1.396-1.462 3.491 3.653L14.602 4 16 5.461 6.887 15 2 9.884Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }